import { task_chat_create, chat_attachment_create, get_task_chat,task_chat_update, chat_audio_create,get_tasklist_chat  } from '../Models/chat';

//======== CHAT ========
export const onCreateChat = (data) => {
    return new Promise((resolve, reject) => {
        task_chat_create(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: 'ok', msg: val.msg, data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

export const onGetChat = (data) => {
    return new Promise((resolve, reject) => {
        get_task_chat(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: 'ok', msg: val.msg,  data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

export const onGetTasklistChat = (data) => {
    return new Promise((resolve, reject) => {
        get_tasklist_chat(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: 'ok', msg: val.msg,  data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

export const onUpdateChat = (data) => {
    return new Promise((resolve, reject) => {
        task_chat_update(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: 'ok', msg: val.msg,  data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

//======== ATTACHMENT =======
export const onCreateAttachment = (data) => {
    return new Promise((resolve, reject) => {
        const formData = new FormData();
        for(var i =0; i< data.length;i++){
            //imgInfo.push(fileList[i].uid)
            //imgArr.push(fileList[i].originFileObj)
            formData.append("files", data[i].originFileObj);
        }
        // formData.append("file", data);

        chat_attachment_create(formData).
        then((response) => response.json()).
        then(val => {
            resolve({ status: 'ok', msg: val.msg,  data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

//======== AUDIO =======
export const onCreateAudio = (data) => {
    return new Promise((resolve, reject) => {
        const formData = new FormData();
       
       
        formData.append("files", data);
        
        // formData.append("file", data);

        chat_audio_create(formData).
        then((response) => response.json()).
        then(val => {
            resolve({ status: 'ok', msg: val.msg,  data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}